module.exports = __webpack_public_path__ + "static/media/ic-eva_alert-triangle.2885dee7.svg";